import { Box, Button, Grid, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import orderSumitted from '../../../assets/Images/order_submitted_illustration.png'
import { ArrowBackOutlined, ArrowForward, ArrowForwardIos, Check, Info, LocalShipping, LocationPin, Schedule, TextSnippet, Verified, VerifiedUser } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../Redux/store';
import { setActiveCartStep } from '../../../Redux/Reducers/globalSlice';
import { toast } from 'react-toastify';
import { ApiGetOrderbyId } from '../../../Core/Apicall';
import { Orders } from '../../../types/Orders';
import dayjs from 'dayjs';

function OrderCompleted() {
    const [activeStep, setActiveStep] = React.useState(1);
    const { userDetails, selectedOrder } = useSelector((state: RootState) => state.global)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [order, setOrderDetails] = useState<Orders>()
    const steps = [
        {
            label: 'Review',
            description: `Your order details and items will be reviewd`,
        },
        {
            label: 'Approval / rejection',
            description:
                `Once approved, you'll get a notification and the order will be confirmed'`,
        },
        {
            label: 'Processing & Shipping',
            description: `After Confirmation, the order will be processed and shipped to you.`,
        },
    ];

    const getOrderDetails = async() =>{
        try {
            const data =`?orderId=${selectedOrder?.orderId}`
            const res= await ApiGetOrderbyId(data)
            if(res?.status){
                setOrderDetails(res?.data)
            }
        } catch (error:any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(()=>{
        getOrderDetails()
    },[])
    return (
        <Box>
            <Box className='d-flex flex-column align-items-center justify-content-start mt-4'>
                <Box component={'img'} src={orderSumitted} sx={{ height: { xs: "80px", md: '120px' } }} className='mb-3' />
                <Typography sx={{ fontSize: { xs: "24px", md: "42px" } }} className='text-dark-main text-center fw-bold mb-1'>Your Order Has Been Submitted</Typography>
                <Typography variant='body2' className='text-grey text-center'>Your order {order?.orderNumber} has been sent to for approval. <br className='d-none d-md-block' /> Once it reviewed and approved, your order will be confirmed</Typography>
            </Box>
            <Grid container className='my-3 bg-white p-3 border-10'>
                <Grid size={{ xs: 12, md: 'grow' }}>
                    <Box className='d-flex flex-row flex-md-column align-items-center gap-2'>
                        <Box className='bg-main p-2 border-10'>
                            <Check className='text-white' />
                        </Box>
                        <Box className='d-flex flex-column align-items-md-center'>
                            <Typography variant='body1' sx={{ lineHeight: 'normal' }} className='fw-bold text-md-center'>Oreder Placed</Typography>
                            <Typography variant='caption' className='text-grey text-md-center'>{dayjs(order?.created_at).format('DD MMM YYYY, hh:mm a')}</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: "auto" }}>
                    <ArrowForwardIos className='text-main d-none d-md-inline-block' />
                    <Box className='ms-3 d-inline-block d-md-none' sx={{ border: '1px solid grey', height: '50px', width: "1px" }}></Box>
                </Grid>
                <Grid size={{ xs: 12, md: 'grow' }}>
                    <Box className='d-flex flex-row flex-md-column align-items-center gap-2'>
                        <Box className='bg-main p-2 border-10'>
                            <Schedule className='text-white' />
                        </Box>
                        <Box className='d-flex flex-column align-items-md-center'>
                            <Typography variant='body1' sx={{ lineHeight: 'normal' }} className='fw-bold text-md-center'>Pending Approval</Typography>
                            <Typography variant='caption' className='text-grey text-md-center'>waiting for review</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: "auto" }}>
                    <ArrowForwardIos className='text-main d-none d-md-inline-block' />
                    <Box className='ms-3 d-inline-block d-md-none' sx={{ border: '1px solid grey', height: '50px', width: "1px" }}></Box>
                </Grid>
                <Grid size={{ xs: 12, md: 'grow' }}>
                    <Box className='d-flex flex-row flex-md-column align-items-center gap-2'>
                        <Box className='bg-grey p-2 border-10'>
                            <Check className='text-dark' />
                        </Box>
                        <Box className='d-flex flex-column align-items-md-center'>
                            <Typography variant='body1' sx={{ lineHeight: 'normal' }} className='fw-bold text-md-center'>Order Confirmed</Typography>
                            <Typography variant='caption' className='text-grey text-md-center'>(After approval)</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: "auto" }}>
                    <ArrowForwardIos className='text-main d-none d-md-inline-block' />
                    <Box className='ms-3 d-inline-block d-md-none' sx={{ border: '1px solid grey', height: '50px', width: "1px" }}></Box>
                </Grid>
                <Grid size={{ xs: 12, md: 'grow' }}>
                    <Box className='d-flex flex-row flex-md-column align-items-center gap-2'>
                        <Box className='bg-grey p-2 border-10'>
                            <LocalShipping className='text-dark' />
                        </Box>
                        <Box className='d-flex flex-column align-items-md-center'>
                            <Typography variant='body1' sx={{ lineHeight: 'normal' }} className='fw-bold text-md-center'>Shipping</Typography>
                            <Typography variant='caption' className='text-grey text-md-center'>(After Confirmation)</Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container className='my-3' spacing={2}>
                <Grid size={{ xs: 12, md: 6 }} className='my-3 bg-white p-3 border-10'>
                    <Box className='d-flex align-items-center gap-2'>
                        <TextSnippet className='text-dark-main' />
                        <Typography variant='body1' className='fw-bold text-dark-main'>Order Details</Typography>
                    </Box>
                    <hr />
                    <Box className='d-flex align-items-center justify-content-between mb-2'>
                        <Typography variant='body2' className='text-grey'>Order Number</Typography>
                        <Typography variant='body2'>{order?.orderNumber}</Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between mb-2'>
                        <Typography variant='body2' className='text-grey'>Order Date</Typography>
                        <Typography variant='body2'>{dayjs(order?.created_at).format('DD MMM YYYY, hh:mm a')}</Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between mb-2'>
                        <Typography variant='body2' className='text-grey'>Total Items</Typography>
                        <Typography variant='body2'>{order?.items?.length}</Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between mb-2'>
                        <Typography variant='body2' className='text-grey'>Total Amount</Typography>
                        <Typography variant='h6' className='text-dark-main fw-bold'>
                            {Number(order?.totalAmount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                        </Typography>
                    </Box>
                    <hr />
                    <Box className='d-flex align-items-center gap-2 mb-2'>
                        <LocationPin className='text-dark-main' />
                        <Typography variant='body1' className='fw-bold text-dark-main'>Delivery Address</Typography>
                    </Box>
                    <Typography variant='body1' className='fw-bold'>{order?.shippingAddress?.contactPerson}</Typography>
                    <Typography variant='body2' className='text-grey'>{order?.shippingAddress?.addressLine1}</Typography>
                    <Typography variant='body2' className='text-grey'>{order?.shippingAddress?.addressLine2}</Typography>
                    <Typography variant='body2' className='text-grey'>{order?.shippingAddress?.city},{order?.shippingAddress?.state}-{order?.shippingAddress?.postalCode},{order?.shippingAddress?.country}</Typography>
                    <Typography variant='body2' className='text-grey'>{order?.shippingAddress?.mobileNumber}</Typography>

                </Grid>
                <Grid size={{ xs: 12, md: 6 }} className='my-3 bg-white p-3 border-10 stepper-2'>
                    <Box className='d-flex align-items-center gap-2 mb-3'>
                        <Info className='text-dark-main' />
                        <Typography variant='body1' className='fw-bold text-dark-main'>What Happens Next?</Typography>
                    </Box>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((step, index) => (
                            <Step key={step.label}>
                                <StepLabel
                                >
                                    <Typography className='text-main' variant='body2'>{step.label}</Typography>
                                    <Typography variant='caption' className='text-dark'>{step.description}</Typography>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <Box className='bg-second-light p-3 d-flex align-items-center gap-2 mt-4 border-10'>
                        <VerifiedUser className='text-main' />
                        <Typography variant='body2' className='text-main'>You'll be notified as soon as there is an update in your order.</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box className='d-flex align-items-center justify-content-start'>
                <Button className='btn-outlined-main px-3 py-2' onClick={()=>{dispatch(setActiveCartStep(0)); navigate(`/${userDetails?.role}/dashboard`)}}><ArrowBackOutlined />&nbsp;Back to Dashboard</Button>
            </Box>
        </Box >
    )
}

export default OrderCompleted
